import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.bannerData && _setup.isVisible
    ? _c(
        "div",
        {
          staticClass: "award-banner",
          class: {
            "award-banner--dark": _setup.bannerData.isDarkMode,
            "ma-2": _setup.isMobile,
            "mb-6": !_setup.isMobile,
          },
          attrs: { "data-qa": "award_banner" },
          on: { click: _setup.handleShowMore },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              class: _setup.isMobile ? "px-2 pt-1 mb-2" : "mr-8",
            },
            [
              _c("img", {
                staticClass: "flex-grow-0",
                class: _setup.isMobile ? "mr-6" : "mr-8",
                attrs: {
                  alt: "Золотая звезда",
                  height: "32",
                  width: "32",
                  src: _setup.starIcon,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-1" }, [
                _vm._v(
                  "\n      " + _vm._s(_setup.bannerData.banner.title) + "\n    "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-auto", class: { "mr-2": !_setup.isMobile } },
            [
              _c(
                VBtn,
                {
                  staticClass: "px-2 mr-2",
                  attrs: { text: "", dark: _setup.bannerData.isDarkMode },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _setup.handleClose.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n      Скрыть\n    ")]
              ),
              _vm._v(" "),
              _c(
                VBtn,
                {
                  staticClass: "px-2",
                  attrs: {
                    text: "",
                    dark: _setup.bannerData.isDarkMode,
                    color: _setup.bannerData.isDarkMode ? "gold" : "primary",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _setup.handleShowMore.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.bannerData.banner.button.moreText) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }